import './App.css';
import Home from './components/Home';
import About from './components/About';
import Skills from './components/Skills';
import Works from './components/Works';
import Contact from './components/Contact';

import Navbar from './components/Navbar';
function App() {
  return (
    <div className="App">
      <div>
      <Navbar />
      <Home />
      <About />
      <Skills />
      <Works />
      <Contact />
    </div>


    </div>
  );
}

export default App;
